import { render, staticRenderFns } from "./gc-table.vue?vue&type=template&id=45693c4b&lang=pug"
import script from "./gc-table.vue?vue&type=script&lang=coffee"
export * from "./gc-table.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports